;(function (angular) {
   'use strict'

   angular
      .module('app')
      .controller('ProductCtrl', function (
         $window,
         $scope,
         $rootScope,
         $state,
         $timeout,
         $sce,
         appState,
         product,
         productData,
         modalService,
         renderProductDescription,
         util
      ) {
         //================================================================================
         // Vars
         //================================================================================

         $scope.featurePath = 'product'

         product.description = renderProductDescription(product.description)
         product.inactiveDescription = renderProductDescription(product.inactiveDescription)

         $scope.product = product
         if (!product.selectedPackaging && product.packaging.length === 1) {
            product.selectPackaging(product.packaging[0].code)
         }
         $scope.images = product.selectedPackaging ? product.selectedPackaging.images : product.images
         $scope.localState = {
            mobileSelectOpen: false,
         }
         $scope.hasOrderedProduct = appState.userState.hasOrderedByPackaging(product.packaging)
         if ($scope.hasOrderedProduct) {
            setOrderedPackagedProduct()
            $scope.orderedSummary = appState.userState.orderedSummaryByPackaging(product.packaging)
            $scope.lastOrderedPack = util.findByPropertyValue(product.packaging, 'code', $scope.orderedSummary.code)
         }
         $scope.productPackagingCodes = util.mapToProperty('code', product.packaging).join()

         $scope.stockStatusDisplay = {}
         $scope.stockStatusDisplay[productData.stockStatuses.inStock] = {
            status: 'In Stock',
            message: '',
         }
         $scope.stockStatusDisplay[productData.stockStatuses.outOfStock] = {
            status: 'Out of Stock',
            message: '',
         }
         $scope.stockStatusDisplay[productData.stockStatuses.arrivingAfterOrder] = {
            status: 'Arriving Soon',
            message: 'Note: Though we expect more of this item soon, it is unlikely to arrive before your order ships.',
         }
         $scope.stockStatusDisplay[productData.stockStatuses.arrivingBeforeOrder] = {
            status: 'Arriving Soon',
            message: 'Note: Though currently out of stock, this item should be available by the time your order ships.',
         }
         $scope.stockStatusDisplay[productData.stockStatuses.vendorOutOfStockUpcomingOrder] = {
            status: 'Supplier Out of Stock',
            message:
               'Note: This product is temporarily unavailable as our supplier was unable to fulfill our latest order.',
         }
         $scope.stockStatusDisplay[productData.stockStatuses.vendorOutOfStockNoUpcomingOrder] = {
            status: 'Supplier Out of Stock',
            message: $sce.trustAsHtml(
               'Note: This product is temporarily unavailable as our supplier was unable to fulfill our latest order.' +
                  '<br><br>No current estimated time of arrival.'
            ),
         }
         //================================================================================
         // Scope Functions
         //================================================================================

         $scope.openMobileSelect = function () {
            $scope.localState.mobileSelectOpen = true
         }

         $scope.closeMobileSelect = function () {
            $scope.localState.mobileSelectOpen = false
            $rootScope.removeUnderlayClass()
         }

         const _schemaHost = 'http://schema.org/'

         function setOrderedPackagedProduct() {
            $scope.orderedPackagedProduct =
               appState.userState.user &&
               util.findByPropertyValue(
                  appState.userState.orderedPackagedProducts,
                  'code',
                  product.selectedPackaging.code
               )
         }

         function schemaItemAvailability(pack) {
            let availability
            if (pack.isDiscontinued) {
               availability = 'Discontinued'
            } else if (pack.isOutOfStock) {
               availability = 'OutOfStock'
            } else {
               availability = 'InStock'
            }
            return _schemaHost + availability
         }

         const addBrandJSONLD = function (data) {
            if (product.brand) {
               data.brand = {
                  '@type': 'Brand',
                  name: product.brand.name,
               }
               if (product.brand.url) {
                  data.brand.url = product.brand.url
               }
            }
         }

         const productJSONLD = function (pack) {
            const data = {
               '@context': _schemaHost,
               '@type': 'Product',
               name: product.name + ', ' + pack.size,
               inProductGroupWithID: product.id,
               sku: pack.code,
               mpn: pack.code,
               size: pack.size,
            }
            if (pack.userPrice) {
               data.offers = {
                  '@type': 'Offer',
                  url: util.absoluteUrl(
                     $state.href('shop.product', {id: product.id, path: product.path, package: pack.code})
                  ),
                  priceCurrency: 'USD',
                  price: pack.userPrice.dollarsMedian.toFixed(2).toString(),
                  itemCondition: _schemaHost + 'NewCondition',
                  availability: schemaItemAvailability(pack),
               }
            }
            if (product.shortDescription) {
               data.description = product.shortDescription
            }
            addBrandJSONLD(data)
            if (pack.images.length) {
               data.image = pack.images.map(function (url) {
                  return 'https://img.azurestandard.com/unsafe/fit-in/536x536/filters:fill(white)/' + url
               })
            }
            if (pack.gtin13) {
               data.gtin13 = pack.gtin13
            }
            if (pack.trustpilotNumberOfReviews) {
               data.aggregateRating = {
                  '@type': 'AggregateRating',
                  ratingValue: pack.trustpilotStarsAverage,
                  reviewCount: pack.trustpilotNumberOfReviews,
               }
            }
            return data
         }

         const productGroupJSONLD = function () {
            const data = {
               '@context': _schemaHost,
               '@type': 'ProductGroup',
               name: product.name,
               url: util.absoluteUrl($state.href('shop.product', {id: product.id, path: product.path})),
               productGroupID: product.id,
               variesBy: ['size'],
               hasVariant: product.packaging.map(productJSONLD),
            }
            addBrandJSONLD(data)
            return data
         }

         $scope.getJSONLD = function () {
            const data = product.selectedPackaging ? productJSONLD(product.selectedPackaging) : productGroupJSONLD()
            return JSON.stringify(data)
         }

         function sortByOutOfStockComparer(productA, productB) {
            if (productA.packaging[0].isOutOfStockOn(appState.pickDate)) {
               return 1
            }
            if (productB.packaging[0].isOutOfStockOn(appState.pickDate)) {
               return -1
            }
            return 0
         }

         function checkForOutWithSubs() {
            if (!product.selectedPackaging || product.selectedPackaging.isOutOfStockOn(appState.pickDate)) {
               const options = {
                  priceSettings: appState.userState.priceSettings,
                  removeInactivePackaging: true,
               }
               const inStockSubsOnly = product.selectedPackaging && !product.selectedPackaging.isInactive
               if (inStockSubsOnly) {
                  options.inStockOn = appState.pickDate
               }
               product.getSubstitutionViews(options).then(function (substitutionViews) {
                  const allSubstitutions = substitutionViews.staffPicks.concat(substitutionViews.bySearch)
                  if (!inStockSubsOnly) {
                     // If displaying out-of-stock subs, we want them displayed last
                     allSubstitutions.sort(sortByOutOfStockComparer)
                  }
                  $scope.localState.substitutionViews = allSubstitutions
               })
            } else {
               $scope.localState.substitutionViews = undefined
            }
         }

         $scope.setTrustpilotHeight = function () {
            if ($rootScope.viewportSm) {
               return '560px'
            }

            switch (product.trustpilotNumberOfReviews) {
               case 1:
                  return '560px'
               case 2:
                  return '740px'
               default:
                  return '910px'
            }
         }

         //================================================================================
         // Event Handling / Watchers
         //================================================================================

         this.uiOnParamsChanged = function (params) {
            if (!params.package) {
               return
            }

            // Ensure that the mobile package select dropdown is closed
            $scope.localState.mobileSelectOpen = false

            // Select the clicked packaged
            product.selectPackaging(params.package)

            if (product.selectedPackaging) {
               $scope.images = product.selectedPackaging.images
               setOrderedPackagedProduct()
            } else {
               // If the package is not in the product view, reload the state to
               // load the product again while requiring this package
               $state.reload()
            }
         }

         $scope.freightHandlingRequiredMoreInfo = function () {
            return modalService.freightHandlingRequired()
         }

         function watchGroupHandler() {
            checkForOutWithSubs()
            if (!product.selectedPackaging) {
               return
            }
            // Load pack data from API (used for most accurate stock counts and order arrival dates)
            return product.selectedPackaging
               .refreshStockData(appState.userState.priceSettings)
               .then(checkForOutWithSubs)
         }

         // Reminder: `$watchGroup` is called once on controller init
         $scope.$watchGroup(['product.selectedPackaging', 'activeOrderState.order.tripView'], watchGroupHandler)

         //================================================================================
         // Init
         //================================================================================

         function init() {
            // If this product has reviews, attempt to load the Trustpilot "trustbox" widget
            if (product.trustpilotNumberOfReviews) {
               $timeout(function () {
                  const trustbox = document.getElementById('js-trustbox')
                  if ($window.Trustpilot) {
                     $window.Trustpilot.loadFromElement(trustbox)
                  } else {
                     trustbox.remove()
                     $scope.trustpilotFailedToLoad = true
                  }
               })
            }
         }

         init()
      })
})(angular)
